import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const STORAGE_KEY = 'sidebar-collapsed';

@Injectable({
  providedIn: 'root'
})
export class SidebarStateService {
  private readonly collapsedSubject = new BehaviorSubject<boolean>(this.lerEstadoSalvo());
  readonly collapsed$ = this.collapsedSubject.asObservable();

  get collapsed(): boolean {
    return this.collapsedSubject.value;
  }

  toggle(): void {
    this.definirColapsado(!this.collapsedSubject.value);
  }

  // Usado para recolher automaticamente em telas de celular (ver Sidebar).
  // Nao grava no localStorage de proposito - e um ajuste de viewport, nao uma
  // preferencia do usuario, entao nao deve sobrescrever a preferencia salva
  // quando ele depois abrir o app num desktop.
  colapsarPorViewport(): void {
    this.collapsedSubject.next(true);
  }

  private definirColapsado(colapsado: boolean): void {
    this.collapsedSubject.next(colapsado);

    try {
      localStorage.setItem(STORAGE_KEY, String(colapsado));
    } catch {
      // Armazenamento indisponível (ex.: navegação privada) - ignora, o estado
      // ainda funciona normalmente durante a sessão atual.
    }
  }

  private lerEstadoSalvo(): boolean {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'true';
    } catch {
      return false;
    }
  }
}
